import { useEffect, useState } from "react";
import "./MarketMonitoring.css";
import { DemoExchangeData, Exchange, Markets } from "./DemoExchangeData";
import Select from "react-select";
import { Filter, Product } from "../../../store/state/MarketMontitoring/types";
import { filters } from "./Filters";
import {
  COLOR_CODES,
  ColorBlue,
  ColorYellow,
  formatDMY,
  PrimaryColor,
  SecondaryColor,
} from "../../../common";
import { FormatByPriceData, FormatMarketMonitoringData } from "./FormatData";
import { ReLineChart } from "../../../components/recharts/ReCharts";
import { ChartType, LegendKey } from "../../../models/chart_model";
import { buildFormDataRequest } from "../../../Rest_api/Network_utility";
import { FilterTab } from "../../../components/Filters";
import Dropdown from "../../../components/Dropdown";
import { searchStyle } from "../../../components/Search";
import {
  LegendComponent,
  lightenColor,
  ReMixChart,
} from "../../../components/recharts/ReMixCharts";
import { MarketAnalysis } from "./Analysis/MarketAnalysis";
import { DateRangePicker } from "react-date-range";
import { set, setDate } from "date-fns";
import { formatDateString } from "../Auction/Auction";
import { DynamicDatePicker } from "../../../components/DatePicker";
let startMonth: {
  value: number;
  label: string;
} = {
  value: -1,
  label: "",
};
let endMonth: {
  value: number;
  label: string;
} = {
  value: -1,
  label: "",
};
const TABS = ["Comparision", "Analysis"];

export function MarketMontoring() {
  useEffect(() => {
    // Only fetch data if we have valid month values or if this is the initial load
    if (startMonth.value !== -1 && endMonth.value !== -1) {
      fetchVolumeData({
        selectedExchange,
        selectedMarket,
        selectedProduct: selectedFilter,
        startMonth,
        endMonth,
      });
      fetchexchangeData({
        selectedExchange,
        selectedMarket,
        selectedProduct: byPriceProduct,
        startMonth,
        endMonth,
      });
    } else if (isInitialLoad) {
      // For initial load, fetch with empty months to get available data
      fetchVolumeData({
        selectedExchange,
        selectedMarket,
        selectedProduct: selectedFilter,
        startMonth: { value: -1, label: "" },
        endMonth: { value: -1, label: "" },
      });
      fetchexchangeData({
        selectedExchange,
        selectedMarket,
        selectedProduct: byPriceProduct,
        startMonth: { value: -1, label: "" },
        endMonth: { value: -1, label: "" },
      });
    }
  }, []);

  const [priceData, setPriceData] = useState<any[]>([]);
  const [volumeData, setVolumeData] = useState<any[]>([]);
  const [chartData, setChartData] = useState<any[]>([]);
  const [tabIndex, setTabIndex] = useState<number>(0);
  const [subTabIndex, setSubTabIndex] = useState<number>(0);
  const [selectedMarket, setSelectedMarket] = useState<Filter[]>(Markets);
  const [selectedExchange, setSelectedExchange] = useState<Filter[]>(Exchange);
  const [visible, setVisible] = useState(false);
  const [dates, setDate] = useState([
    {
      startDate: new Date("2024-04-01"),
      endDate: new Date("2024-07-01"),
      key: "selection",
    },
  ]);
  const [dateRange, setDateRange] = useState(dates[0]);

  const [selectedFilter, setSelectedFilter] = useState<Product[]>(
    getProducts({
      exchange: selectedExchange,
      market: selectedMarket,
    })
  );
  const [byPriceProduct, setByPriceProduct] = useState<Product>(
    getProducts({
      exchange: selectedExchange,
      market: selectedMarket,
    })[0]
  );
  const [selectedTab, setSelectedTab] = useState<string>(TABS[0]);
  const [monthOptions, setMonthOptions] = useState<any[]>([]);
  const [isLoadingMonths, setIsLoadingMonths] = useState<boolean>(true);
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);
  // reset t

  const byVolumeKeys: LegendKey[] = [
    // DAM: "DAM",
    // RTM: "RTM",
    // HPDAM: "HPDAM",
    // GDAM: "GDAM",
    // "Intra-Day Contracts": "Intra Day",
    // "Day Ahead Contingency Contracts": "DAC",
    // "Daily Contracts": "Daily",
    // "Weekly Contracts": "Weekly",
    // "Monthly Contracts": "Monthly",
    // "Any Day Single Sided Contracts": "Any Day S.S",
    {
      dataKey: "dam",
      name: "DAM",
      api_key: "DAM",
      stroke: COLOR_CODES.dam,
    },
    {
      dataKey: "rtm",
      name: "RTM",
      api_key: "RTM",
      stroke: COLOR_CODES.rtm,
    },
    {
      dataKey: "hpdam",
      name: "HPDAM",
      api_key: "HPDAM",
      stroke: COLOR_CODES.hpdAm,
    },
    {
      dataKey: "gdam",
      name: "GDAM",
      api_key: "GDAM",

      stroke: COLOR_CODES.gdam,
    },

    {
      dataKey: "intraDay",
      name: "Intra Day",
      api_key: "Intra-Day Contracts",
      stroke: COLOR_CODES.intraday,
    },
    {
      dataKey: "contingencyContracts",
      name: "DAC",
      api_key: "Day Ahead Contingency Contracts",
      stroke: COLOR_CODES.dac,
    },
    {
      dataKey: "daily",
      name: "Daily",
      api_key: "Daily Contracts",

      stroke: COLOR_CODES.daily,
    },
    {
      dataKey: "weekly",
      name: "Weekly",
      api_key: "Weekly Contracts",
      stroke: COLOR_CODES.weekly,
    },
    {
      dataKey: "monthly",
      name: "Monthly",
      api_key: "Monthly Contracts",
      stroke: COLOR_CODES.monthly,
    },
    {
      dataKey: "singleSided",
      name: "Any Day S.S",
      api_key: "Any Day Single Sided Contracts",
      stroke: COLOR_CODES.anydaySSC,
    },
    {
      dataKey: "bilateral",
      name: "Bilateral",
      api_key: "Bilateral",
      stroke: COLOR_CODES.bilateral,
    },
  ];

  const byProductKeys: LegendKey[] = [
    {
      dataKey: "iex",
      name: "IEX",
      stroke: "rgb(18, 35, 158)",
    },
    {
      dataKey: "hpx",
      name: "HPX",
      stroke: "rgb(17, 141, 255)",
    },
    {
      dataKey: "pxil",
      name: "PXIL",
      stroke: "rgb(230, 108, 55)",
    },
    {
      dataKey: "traders",
      name: "Traders",
      stroke: "#343C6A",
    },
  ];

  return (
    <div>
      <div className="header">
        <h1>Market Monitoring</h1>

        <FilterTab
          options={TABS}
          selected={[selectedTab]}
          onClick={(option, index) => {
            setSelectedTab(option);
          }}
        />
        <div className="header-side-area">
          {selectedTab === "Comparision" && (
            <div className="flex space-x-2">
              <Select
                placeholder={isLoadingMonths ? "Loading months..." : "Start Month"}
                styles={searchStyle as any}
                className="dateSelect"
                isLoading={isLoadingMonths}
                isDisabled={isLoadingMonths}
                value={
                  startMonth.value != -1
                    ? {
                        value: startMonth.value as any,
                        label: startMonth.label,
                      }
                    : undefined
                }
                options={monthOptions.length > 0 ? monthOptions.reverse().map((item) => {
                  if (
                    endMonth.value === -1 ||
                    parseInt(item.id.toString()) <
                      parseInt(endMonth.value.toString())
                  ) {
                    return {
                      value: item.id,
                      label: item.title,
                    };
                  } else {
                    return {
                      value: item.id,
                      label: item.title,
                      isDisabled: true,
                    };
                  }
                }) : []}
                onChange={(selectedOption) => {
                  startMonth = {
                    value: selectedOption!.value as number,
                    label: selectedOption!.label,
                  };
                  fetchVolumeData({
                    selectedExchange,
                    selectedMarket,
                    selectedProduct: selectedFilter,
                    startMonth,
                    endMonth,
                  });
                  fetchexchangeData({
                    selectedExchange,
                    selectedMarket,
                    selectedProduct: byPriceProduct,
                    startMonth,
                    endMonth,
                  });
                }}
              />
              <Select
                placeholder={isLoadingMonths ? "Loading months..." : "End Month"}
                className="dateSelect"
                styles={searchStyle as any}
                isLoading={isLoadingMonths}
                isDisabled={isLoadingMonths}
                value={
                  endMonth.value != -1
                    ? {
                        value: endMonth.value as any,
                        label: endMonth.label,
                      }
                    : undefined
                }
                options={monthOptions.length > 0 ? monthOptions.map((item) => {
                  if (
                    parseInt(item.id.toString()) >
                    parseInt(startMonth.value.toString())
                  ) {
                    return {
                      value: item.id,
                      label: item.title,
                    };
                  } else {
                    return {
                      value: item.id,
                      label: item.title,
                      isDisabled: true,
                    };
                  }
                }).reverse() : []}
                onChange={(selectedOption) => {
                  endMonth = {
                    value: selectedOption!.value as number,
                    label: selectedOption!.label,
                  };
                  fetchVolumeData({
                    selectedExchange,
                    selectedMarket,
                    selectedProduct: selectedFilter,
                    startMonth,
                    endMonth,
                  });
                  fetchexchangeData({
                    selectedExchange,
                    selectedMarket,
                    selectedProduct: byPriceProduct,
                    startMonth,
                    endMonth,
                  });
                }}
              />
            </div>
          )}
          {selectedTab === "Analysis" && (
            <DynamicDatePicker
              defaultDates={dateRange}
              setDate={(date) => {
                setDateRange({
                  startDate: date[0].startDate,
                  endDate: date[0].endDate,
                  key: "selection",
                });

                setDate(date);
              }}
            />
          )}
        </div>
      </div>
      {selectedTab === "Comparision" && (
        <div className="c">
          <div className="body-column-container">
            <div className="filter-horizontal mt-2">
              <div className="flex space-x-8">
                {tabIndex === 0 && (
                  <FilterTab
                    options={Exchange.map((item) => item.name)}
                    selected={selectedExchange.map((item) => item.name)}
                    isSecondary={true}
                    isRounded={true}
                    onClick={(option, index) => {
                      let filter;
                      if (selectedExchange.length === 4) {
                        setSelectedExchange([Exchange[index]]);
                      } else if (selectedExchange.includes(Exchange[index])) {
                        setSelectedExchange(
                          selectedExchange.filter((i) => i !== Exchange[index])
                        );
                        filter = selectedExchange.filter(
                          (i) => i !== Exchange[index]
                        );
                        if (filter.length === 0) {
                          setSelectedExchange(Exchange);
                          filter = Exchange;
                        }
                      } else {
                        setSelectedExchange([
                          ...selectedExchange,
                          Exchange[index],
                        ]);
                        filter = [...selectedExchange, Exchange[index]];
                      }
                    }}
                  />
                )}
                <Dropdown
                  options={["Cumulative", "Comparative"]}
                  selected={["Cumulative", "Comparative"][tabIndex]}
                  onSelect={(option, index) => {
                    setTabIndex(index);
                  }}
                />
              </div>
              <FilterTab
                options={Markets.map((item) => item.name)}
                selected={selectedMarket.map((item) => item.name)}
                onClick={(option, index) => {
                  let filter;
                  if (selectedMarket.length === 3) {
                    setSelectedMarket([Markets[index]]);
                    filter = [Markets[index]];
                  } else if (selectedMarket.includes(Markets[index])) {
                    setSelectedMarket(
                      selectedMarket.filter((i) => i !== Markets[index])
                    );
                    filter = selectedMarket.filter((i) => i !== Markets[index]);
                    if (filter.length === 0) {
                      setSelectedMarket(Markets);
                      filter = Markets;
                    }
                  } else {
                    setSelectedMarket([...selectedMarket, Markets[index]]);
                    filter = [...selectedMarket, Markets[index]];
                  }
                }}
              />

              {tabIndex === 1 && (
                <FilterTab
                  options={getProducts({
                    exchange: selectedExchange,
                    market: selectedMarket,
                  }).map((item) => item.dname ?? item.name)}
                  selected={[byPriceProduct.dname ?? byPriceProduct.name]}
                  onClick={(option, index) => {
                    setByPriceProduct(
                      getProducts({
                        exchange: selectedExchange,
                        market: selectedMarket,
                      })[index]
                    );
                  }}
                />
              )}
            </div>

            <div className="markeMonitoring-chart-container">
              <div className="markeMonitoring-chart">
                {tabIndex == 0 && (
                  <>
                    <div className="flex gap-x-8 justify-center">
                      {LegendComponent(
                        {
                          dataKey: "total_mu",
                          stroke: COLOR_CODES.secondary,
                          name: "Volume(MUs)",
                          type: 1,
                          legendColor: COLOR_CODES.secondary,
                        },
                        0,
                        [],
                        () => {}
                      )}
                      {LegendComponent(
                        {
                          dataKey: "weighted_avg_rs_per_kwh",
                          stroke: COLOR_CODES.secondary,
                          name: "Wt. Avg Price(Rs/KWh)",
                          yAxisId: "right",
                        },
                        1,
                        [],
                        () => {}
                      )}
                    </div>
                    <ReMixChart
                      yAxisLabel={"Weighted Average Price (Rs/KWh)"}
                      secondYAxisWidth={80}
                      xLabel="Month"
                      yAxisWidth={50}
                      unit={"MUs"}
                      data={
                        FormatMarketMonitoringData(
                          priceData,
                          selectedExchange.map((e) => e.name),
                          [
                            ...selectedMarket.map((e) => e.name),
                            "Traders",
                            "Bilateral",
                          ],
                          true
                        ) as any
                      }
                      legendBreakIndex={
                        byVolumeKeys.filter(
                          (e) =>
                            getProducts({
                              exchange: selectedExchange,
                              market: selectedMarket,
                            }).filter(
                              (product) =>
                                product.dname == (e.name ?? e.dataKey)
                            ).length > 0
                        ).length - 1
                      }
                      secondYAxisLabel="Volume (MU)"
                      legends={[
                        ...byVolumeKeys
                          .filter(
                            (e) =>
                              getProducts({
                                exchange: selectedExchange,
                                market: selectedMarket,
                              }).filter(
                                (product) =>
                                  product.dname == (e.name ?? e.dataKey)
                              ).length > 0
                          )
                          .flat()
                          .map((e) => {
                            return {
                              dataKey: e.dataKey + "_volume",
                              name: e.name,
                              stroke: lightenColor(e.stroke as any, 20),
                              yAxisId: "right",
                              type: ChartType.Bar,
                            };
                          }),
                        ...byVolumeKeys
                          .filter(
                            (e) =>
                              getProducts({
                                exchange: selectedExchange,
                                market: selectedMarket,
                              }).filter(
                                (product) =>
                                  product.dname == (e.name ?? e.dataKey)
                              ).length > 0
                          )
                          .flat()
                          .map((e) => {
                            return {
                              dataKey: e.dataKey,
                              name: e.name + " Price",
                              stroke: e.stroke,
                            };
                          }),
                      ]}
                      xDataKey="month"
                    />
                  </>
                )}
                {tabIndex == 1 && (
                  <>
                    <div className="flex justify-center">
                      {/* <h2 className="chartHeading">
                    By Volume ({VOLUME_UNIT})</h2> */}
                      <h2 className="chartHeading">
                        {subTabIndex == 0
                          ? "By Volume (MU)"
                          : "By Price (Rs/KWh)"}
                      </h2>
                    </div>
                    <ReMixChart
                      xLabel="Month"
                      yAxisLabel={
                        subTabIndex == 0
                          ? "Volume (MU)"
                          : "Weighted Average Price (Rs/KWh)"
                      }
                      yAxisWidth={80}
                      data={FormatByPriceData(
                        priceData,
                        [byPriceProduct.name, "Trading Licensees"],
                        [...selectedMarket.map((e) => e.name), "Traders"],
                        true
                      )}
                      legends={[
                        ...byProductKeys.map((e) => {
                          return {
                            dataKey: e.dataKey + "_volume",
                            name: e.name,
                            type: ChartType.Bar,
                            stroke: lightenColor(e.stroke!, 40),
                            yAxisId: "right",
                          };
                        }),
                        ...byProductKeys.map((e) => {
                          return {
                            dataKey: e.dataKey,
                            name: e.name + " Price",
                            stroke: e.stroke,
                          };
                        }),
                      ]}
                      unit={subTabIndex == 0 ? "MU" : "Rs/KWh"}
                      xDataKey="month"
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {selectedTab === "Analysis" && <MarketAnalysis dates={dates} />}
    </div>
  );

  async function fetchVolumeData({
    selectedExchange,
    selectedMarket,
    selectedProduct,
    startMonth,
    endMonth,
  }: {
    selectedExchange: Filter[];
    selectedMarket: Filter[];
    selectedProduct: Product[];
    startMonth: { value: number; label: string };
    endMonth: { value: number; label: string };
  }) {
    const res = await buildFormDataRequest({
      endpoint: "data/market_monitoring_volume_api",
      method: "POST",
      body: {
        exchange: "HPX,IEX,PXIL,Traders",
        market: selectedMarket.map((item) => item.name).toString(),
        product: selectedProduct.map((item) => item.name).toString(),
        start_month: startMonth.label,
        end_month: endMonth.label,
      },
    });

    setVolumeData(res);

    // Set dynamic month options on first load
    if (isInitialLoad) {
      if (res && res.length > 0) {
        const availableMonths = extractAvailableMonths(res);
        setMonthOptions(availableMonths);
        
        // Set default start and end months if not already set
        if (startMonth.value === -1 && availableMonths.length > 0) {
          startMonth = {
            value: availableMonths[0].value,
            label: availableMonths[0].label,
          };
        }
        if (endMonth.value === -1 && availableMonths.length > 0) {
          endMonth = {
            value: availableMonths[availableMonths.length - 1].value,
            label: availableMonths[availableMonths.length - 1].label,
          };
        }
      } else {
        // Fallback to static month options if API doesn't return data
        setMonthOptions(filters[2].subfilter);
      }
      setIsLoadingMonths(false);
      setIsInitialLoad(false);
    }

    tabIndex == 0 && setChartData(FormatMarketMonitoringData(res));
  }

  async function fetchexchangeData({
    selectedExchange,
    selectedMarket,
    selectedProduct,
    startMonth,
    endMonth,
  }: {
    selectedExchange: Filter[];
    selectedMarket: Filter[];
    selectedProduct: Product;
    startMonth: { value: number; label: string };
    endMonth: { value: number; label: string };
  }) {
    const byPrice = await buildFormDataRequest({
      endpoint: "data/market_monitoring_price_api",
      method: "POST",
      body: {
        exchange: "HPX,IEX,PXIL,Traders",
        market: selectedMarket.map((item) => item.name).toString(),
        product:
          byVolumeKeys.map((item) => item.api_key).toString() +
          ",Trading Licensees",
        start_month: startMonth.label,
        end_month: endMonth.label,
      },
    });
    tabIndex == 1 && setChartData(FormatByPriceData(byPrice));
    console.log("Setting by Price - ", byPrice);
    console.log(byPrice);
    setPriceData(byPrice);
  }

  function getProducts({
    market,
    exchange,
  }: {
    market: Filter[];
    exchange: Filter[];
  }): Product[] {
    const PRODUCT_MAPPING: { [key: string]: string } = {
      DAM: "DAM",
      RTM: "RTM",
      HPDAM: "HPDAM",
      GDAM: "GDAM",
      "Intra-Day Contracts": "Intra Day",
      "Day Ahead Contingency Contracts": "DAC",
      "Daily Contracts": "Daily",
      "Weekly Contracts": "Weekly",
      "Monthly Contracts": "Monthly",
      "Any Day Single Sided Contracts": "Any Day S.S",
      Bilateral: "Bilateral",
    };
    const marketProducts = market.flatMap((m) => m.products);
    const exchangeProducts = exchange.flatMap((e) => e.products);

    const uniqueMarketProducts = Array.from(new Set(marketProducts));
    const uniqueExchangeProducts = Array.from(new Set(exchangeProducts));

    let commonProducts = uniqueMarketProducts.filter((mp) =>
      uniqueExchangeProducts.some((ep) => ep.id === mp.id)
    );
    if (exchange.filter((item) => item.name == "Traders").length !== 0) {
      tabIndex == 0 &&
        commonProducts.push({ id: 13, name: "Bilateral", dname: "Bilateral" });
    }
    commonProducts = commonProducts.map((item) => {
      return {
        ...item,
        dname: PRODUCT_MAPPING[item.name as any] as any,
      };
    });

    return commonProducts;
  }

  // Function to extract available months from API response
  function extractAvailableMonths(data: any[]): any[] {
    if (!data || data.length === 0) return [];
    
    // Extract unique months from the data
    const months = new Set<string>();
    data.forEach(item => {
      if (item.month) {
        months.add(item.month);
      }
    });
    
    // Convert to array and sort by date
    const sortedMonths = Array.from(months).sort((a, b) => {
      const dateA = new Date(a);
      const dateB = new Date(b);
      return dateA.getTime() - dateB.getTime();
    });
    
    // Convert to the format expected by the Select component
    return sortedMonths.map((month, index) => ({
      id: index + 1,
      title: month,
      value: index + 1,
      label: month
    }));
  }
}
